import { configureStore } from '@reduxjs/toolkit'
import { useDispatch } from 'react-redux'
import missionSliceReducer from './missions/missionSlice'
import auditSliceReducer from './audits/auditSlice'
import incidentSliceReducer from './incidents/incidentSlice'
import pipelineSliceReducer from './pipelines/pipelineSlice'
import planSliceReducer from './plans/planSlice'
import risqueSliceReducer from './risques/risqueSlice'
import projetSliceReducer from './projets/projetSlice'
import actionSliceReducer from './actions/actionSlice'
import coutSupplementaireSliceReducer from './CoutSupplementaire/coutSupplementaireSlice'
import delaiSliceReducer from './delais/delaisSlice'
import commentSliceReducer from './comments/commentSlice'
import securityCheckFamilySliceReducer from './securityCheckFamily/securityCheckFamilySlice'
import securityControlsSliceReducer from './securityControls/securityControlsSlice'
import existingControlSliceReducer from './existingControls/existingSlice'
import subDomainSliceReducer from './subDomains/subDomainSlice'
import maturityScoringSliceReducer from './maturityScoring/maturityScoringSlice'
import authSliceReducer from './keycloak/keycloakSlice'
import usersSliceReducer from './users/usersSlice'
import acteurActionReducer from './actorAction/actorActionSlice'
import specificationSliceReducer from './specification/specificationSlice'
import documentSliceReducer from './documents/documentSlice'
import licenseSliceReducer from './license/licenseSlice'
import controlPlaneSliceReducer from './controlPlane/controlPlaneSlice'
export const store = configureStore({
  reducer: {
    auth: authSliceReducer,
    controlPlane: controlPlaneSliceReducer,
    mission: missionSliceReducer,
    audit: auditSliceReducer,
    incident: incidentSliceReducer,
    pipeline: pipelineSliceReducer,
    plan: planSliceReducer,
    risque: risqueSliceReducer,
    projet: projetSliceReducer,
    action: actionSliceReducer,
    coutSupplementaire: coutSupplementaireSliceReducer,
    delai: delaiSliceReducer,
    comment: commentSliceReducer,
    security: securityControlsSliceReducer,
    securitycheckFamily: securityCheckFamilySliceReducer,
    existingControl: existingControlSliceReducer,
    subDomain: subDomainSliceReducer,
    maturityScoring: maturityScoringSliceReducer,
    users: usersSliceReducer,
    acteurAction: acteurActionReducer,
    specification: specificationSliceReducer,
    document: documentSliceReducer,
    license: licenseSliceReducer,
  },
})
export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
export const useAppDispatch = () => useDispatch<AppDispatch>()
